export const ACTIONS = {
    ADD_APPLICATION_HEADER_TITLE: 'ADD_APPLICATION_HEADER_TITLE',
    CLEAR_APPLICATION_HEADER_TITLE: 'CLEAR_APPLICATION_HEADER_TITLE'
};

export function addApplicationHeaderTitle(title) {
    return {
        type: ACTIONS.ADD_APPLICATION_HEADER_TITLE,
        payload: { title }
    };
}

export function clearApplicationHeaderTitle() {
    return {
        type: ACTIONS.CLEAR_APPLICATION_HEADER_TITLE,
        payload: {}
    };
}
